module.exports = __webpack_public_path__ + "assets/images/X.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/X.png
// module id = 1473
// module chunks = 1